/* eslint-disable react/display-name */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 736">
        <defs>
            <style>
                {`
.s2_1,
.s2_2,
.s2_3,
.s2_4{fill:none;}
.s2_2,
.s2_3{stroke:#b2d4ff;stroke-linejoin:round;}
.s2_5{fill:#f99cdb;}
.s2_6{fill:#f797d2;}
.s2_7{fill:#ed50b4;}
.s2_8{fill:#ffe380;}
.s2_9{fill:#fff2fb;}
.s2_10{fill:#ffc400;}
.s2_11{fill:#ffab00;}
.s2_12{fill:#fcc6eb;}
.s2_13,
.s2_14{fill:#b2d4ff;}
.s2_15{fill:#deebff;}
.s2_16{fill:#44c4d9;}
.s2_17{fill:#73c6d3;}
.s2_18{fill:#4c9aff;}
.s2_19,
.s2_20,
.s2_21,
.s2_22,
.s2_23{fill:#79f2c0;}
.s2_3,
.s2_14,
.s2_24,
.s2_25{mix-blend-mode:multiply;}
.s2_3,
.s2_14,
.s2_25{opacity:.2;}
.s2_20{filter:url(#drop-shadow-11);}
.s2_20,
.s2_26,
.s2_23{fill-rule:evenodd;}
.s2_27{filter:url(#drop-shadow-6);}
.s2_4{stroke:#4c9aff;stroke-dasharray:0 0 6 6;stroke-miterlimit:10;stroke-width:2px;}
.s2_28{fill:url(#linear-gradient-8);}
.s2_29{fill:url(#linear-gradient-9);}
.s2_30{fill:url(#linear-gradient-3);}
.s2_31{fill:url(#linear-gradient-4);}
.s2_32{fill:url(#linear-gradient-2);}
.s2_33{fill:url(#linear-gradient-6);}
.s2_34{fill:url(#linear-gradient-7);}
.s2_35{fill:url(#linear-gradient-5);}
.s2_24{fill:url(#radial-gradient);}
.s2_36{opacity:.5;}
.s2_21{filter:url(#drop-shadow-9);}
.s2_37{filter:url(#drop-shadow-8);}
.s2_37,
.s2_26{fill:#fff;}
.s2_38{fill:#e3fcef;filter:url(#drop-shadow-2);}
.s2_22{filter:url(#drop-shadow-10);}
.s2_39{fill:url(#linear-gradient-14);}
.s2_40{fill:url(#linear-gradient-13);}
.s2_41{fill:url(#linear-gradient-12);}
.s2_42{fill:url(#linear-gradient-10);}
.s2_43{fill:url(#linear-gradient-11);}
.s2_44{isolation:isolate;}
.s2_45{fill:url(#linear-gradient);filter:url(#drop-shadow-1);}
.s2_23{filter:url(#drop-shadow-7);}
.s2_46{fill:#1ab9d4;opacity:.3;}
`}
            </style>
            <radialGradient
                id="radial-gradient"
                cx="450"
                cy="368"
                fx="450"
                fy="368"
                r="510.15"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#b2d4ff" />
                <stop offset=".05" stopColor="#b6d6ff" stopOpacity=".95" />
                <stop offset=".15" stopColor="#c0dbff" stopOpacity=".83" />
                <stop offset=".28" stopColor="#d2e4ff" stopOpacity=".63" />
                <stop offset=".36" stopColor="#deebff" stopOpacity=".5" />
                <stop offset=".45" stopColor="#e0ecff" stopOpacity=".47" />
                <stop offset=".59" stopColor="#e6efff" stopOpacity=".38" />
                <stop offset=".77" stopColor="#eff5ff" stopOpacity=".23" />
                <stop offset=".98" stopColor="#fdfdff" stopOpacity=".03" />
                <stop offset="1" stopColor="#fff" stopOpacity="0" />
            </radialGradient>
            <linearGradient
                id="linear-gradient"
                x1="397.36"
                y1="358.56"
                x2="832.9"
                y2="99.01"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".12" stopColor="#2684ff" />
                <stop offset=".53" stopColor="#4c9aff" />
                <stop offset="1" stopColor="#b2d4ff" />
            </linearGradient>
            <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <linearGradient
                id="linear-gradient-2"
                x1="160.26"
                y1="367.36"
                x2="501.19"
                y2="367.36"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-3"
                x1="661.26"
                y1="147.99"
                x2="173.53"
                y2="509.25"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".07" stopColor="#fff" />
                <stop offset=".39" stopColor="#fbfcff" />
                <stop offset=".71" stopColor="#eff5ff" />
                <stop offset="1" stopColor="#deebff" />
            </linearGradient>
            <linearGradient
                id="linear-gradient-4"
                x1="697.53"
                y1="196.95"
                x2="209.79"
                y2="558.21"
                xlinkHref="#linear-gradient-3"
            />
            <linearGradient
                id="linear-gradient-5"
                x1="733.8"
                y1="245.92"
                x2="246.06"
                y2="607.17"
                xlinkHref="#linear-gradient-3"
            />
            <linearGradient
                id="linear-gradient-6"
                x1="690.39"
                y1="187.32"
                x2="202.66"
                y2="548.58"
                xlinkHref="#linear-gradient-3"
            />
            <linearGradient
                id="linear-gradient-7"
                x1="726.66"
                y1="236.28"
                x2="238.93"
                y2="597.54"
                xlinkHref="#linear-gradient-3"
            />
            <linearGradient
                id="linear-gradient-8"
                x1="762.93"
                y1="285.25"
                x2="275.19"
                y2="646.51"
                xlinkHref="#linear-gradient-3"
            />
            <filter id="drop-shadow-2" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-2" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-2" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <linearGradient
                id="linear-gradient-9"
                x1="310.25"
                y1="228.09"
                x2="310.25"
                y2="204.45"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#44c4d9" />
                <stop offset="1" stopColor="#1ab9d4" />
            </linearGradient>
            <linearGradient
                id="linear-gradient-10"
                x1="294.82"
                y1="228.09"
                x2="294.82"
                y2="204.45"
                xlinkHref="#linear-gradient-9"
            />
            <linearGradient
                id="linear-gradient-11"
                x1="309.94"
                y1="228.09"
                x2="309.94"
                y2="204.45"
                xlinkHref="#linear-gradient-9"
            />
            <linearGradient
                id="linear-gradient-12"
                x1="309.28"
                y1="228.09"
                x2="309.28"
                y2="204.45"
                xlinkHref="#linear-gradient-9"
            />
            <linearGradient
                id="linear-gradient-13"
                x1="309.62"
                y1="228.09"
                x2="309.62"
                y2="204.45"
                xlinkHref="#linear-gradient-9"
            />
            <linearGradient
                id="linear-gradient-14"
                x1="294.29"
                y1="228.09"
                x2="294.29"
                y2="204.45"
                xlinkHref="#linear-gradient-9"
            />
            <filter id="drop-shadow-6" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-3" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-3" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-7" filterUnits="userSpaceOnUse">
                <feOffset dx="1.8" dy="1.8" />
                <feGaussianBlur result="blur-4" stdDeviation="1.2" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-4" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-8" filterUnits="userSpaceOnUse">
                <feOffset dx="1.8" dy="1.8" />
                <feGaussianBlur result="blur-5" stdDeviation="1.2" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-5" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-9" filterUnits="userSpaceOnUse">
                <feOffset dx="1.62" dy="1.62" />
                <feGaussianBlur result="blur-6" stdDeviation="1.08" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-6" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-10" filterUnits="userSpaceOnUse">
                <feOffset dx="1.62" dy="1.62" />
                <feGaussianBlur result="blur-7" stdDeviation="1.08" />
                <feFlood floodColor="#0e1f40" floodOpacity=".3" />
                <feComposite in2="blur-7" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
            <filter id="drop-shadow-11" filterUnits="userSpaceOnUse">
                <feOffset dx="1" dy="1" />
                <feGaussianBlur result="blur-8" stdDeviation="1" />
                <feFlood floodColor="#0e1f40" floodOpacity=".15" />
                <feComposite in2="blur-8" operator="in" />
                <feComposite in="SourceGraphic" />
            </filter>
        </defs>
        <g className="s2_44">
            <g id="bg">
                <path
                    className="s2_24"
                    d="m900,67.28v-1h-68.73V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28h-68.23V0h-1v66.28H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v65.78H0v1h68.73v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.23v67.68h1v-67.68h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73v-1h-68.73v-65.78h68.73Zm-138.96,0v65.78h-68.23v-65.78h68.23Zm-345.16,267.13h68.23v65.78h-68.23v-65.78Zm-1,65.78h-68.23v-65.78h68.23v65.78Zm70.23-65.78h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm-69.23,0h-68.23v-65.78h68.23v65.78Zm0,1v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm0,66.78v65.78h-68.23v-65.78h68.23Zm1,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm69.23,0h68.23v65.78h-68.23v-65.78Zm0-1v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm0-66.78v-65.78h68.23v65.78h-68.23Zm-1-132.56v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-69.23,0v65.78h-68.23v-65.78h68.23Zm-137.46,0h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,66.78h68.23v65.78h-68.23v-65.78Zm0,132.56v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm69.23,0v-65.78h68.23v65.78h-68.23Zm137.46,0h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Zm0-66.78h-68.23v-65.78h68.23v65.78Z"
                />
            </g>
            <g id="illos">
                <g>
                    <g>
                        <path
                            className="s2_13"
                            d="m447.51,142.37h340.93v223.94c0,1.1-.9,2-2,2h-338.93v-225.94h0Z"
                        />
                        <rect
                            className="s2_45"
                            x="554.1"
                            y="209.88"
                            width="139.62"
                            height="27.36"
                        />
                        <g>
                            <line
                                className="s2_3"
                                x1="564.98"
                                y1="323.36"
                                x2="610.87"
                                y2="323.36"
                            />
                            <line
                                className="s2_3"
                                x1="564.98"
                                y1="331.18"
                                x2="610.87"
                                y2="331.18"
                            />
                        </g>
                        <g>
                            <line
                                className="s2_3"
                                x1="564.98"
                                y1="347.89"
                                x2="610.87"
                                y2="347.89"
                            />
                            <line
                                className="s2_3"
                                x1="564.98"
                                y1="355.7"
                                x2="610.87"
                                y2="355.7"
                            />
                        </g>
                        <g id="topnav">
                            <rect
                                className="s2_15"
                                x="447.51"
                                y="142.37"
                                width="93.57"
                                height="225.94"
                            />
                        </g>
                        <line
                            className="s2_3"
                            x1="561.74"
                            y1="163.29"
                            x2="693"
                            y2="163.29"
                        />
                        <g className="s2_36">
                            <path
                                className="s2_13"
                                d="m465.55,171.29h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                            />
                            <line
                                className="s2_2"
                                x1="471.12"
                                y1="167.46"
                                x2="518.49"
                                y2="167.46"
                            />
                        </g>
                        <g className="s2_36">
                            <path
                                className="s2_13"
                                d="m465.55,191.93h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                            />
                            <line
                                className="s2_2"
                                x1="471.12"
                                y1="188.1"
                                x2="518.49"
                                y2="188.1"
                            />
                        </g>
                        <g className="s2_36">
                            <path
                                className="s2_13"
                                d="m465.55,212.57h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                            />
                            <line
                                className="s2_2"
                                x1="471.12"
                                y1="208.74"
                                x2="518.49"
                                y2="208.74"
                            />
                        </g>
                        <g className="s2_36">
                            <path
                                className="s2_13"
                                d="m465.55,233.21h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                            />
                            <line
                                className="s2_2"
                                x1="471.12"
                                y1="229.38"
                                x2="518.49"
                                y2="229.38"
                            />
                        </g>
                        <g className="s2_36">
                            <path
                                className="s2_13"
                                d="m465.55,253.85h-4.71c-.41,0-.8-.16-1.08-.45-.29-.29-.45-.68-.45-1.08v-4.6c0-.41.16-.8.45-1.08.29-.29.68-.45,1.08-.45h4.71c.41,0,.8.16,1.08.45.29.29.45.68.45,1.08v4.6c0,.41-.16.8-.45,1.08-.29.29-.68.45-1.08.45Z"
                            />
                            <line
                                className="s2_2"
                                x1="471.12"
                                y1="250.02"
                                x2="518.49"
                                y2="250.02"
                            />
                        </g>
                    </g>
                    <rect
                        className="s2_14"
                        x="561.74"
                        y="177.01"
                        width="38.81"
                        height="9.1"
                    />
                    <rect
                        className="s2_14"
                        x="608.15"
                        y="177.01"
                        width="38.81"
                        height="9.1"
                    />
                    <rect
                        className="s2_14"
                        x="654.56"
                        y="177.01"
                        width="38.81"
                        height="9.1"
                    />
                    <line
                        className="s2_2"
                        x1="584.08"
                        y1="221.09"
                        x2="675.85"
                        y2="221.09"
                    />
                    <line
                        className="s2_2"
                        x1="584.08"
                        y1="228.58"
                        x2="629.74"
                        y2="228.58"
                    />
                    <line
                        className="s2_3"
                        x1="564.98"
                        y1="250.1"
                        x2="610.87"
                        y2="250.1"
                    />
                    <g>
                        <line
                            className="s2_3"
                            x1="564.98"
                            y1="274.31"
                            x2="610.87"
                            y2="274.31"
                        />
                        <line
                            className="s2_3"
                            x1="564.98"
                            y1="282.12"
                            x2="610.87"
                            y2="282.12"
                        />
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="564.98"
                            y1="298.84"
                            x2="610.87"
                            y2="298.84"
                        />
                        <line
                            className="s2_3"
                            x1="564.98"
                            y1="306.65"
                            x2="610.87"
                            y2="306.65"
                        />
                    </g>
                    <line
                        className="s2_3"
                        x1="564.98"
                        y1="257.6"
                        x2="643.75"
                        y2="257.6"
                    />
                    <g>
                        <circle
                            className="s2_13"
                            cx="568.5"
                            cy="223.75"
                            r="6.32"
                        />
                        <path
                            className="s2_18"
                            d="m570.05,221.48c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <polyline
                        className="s2_3"
                        points="711.02 360.83 711.02 199.43 561.74 199.43"
                    />
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="206.15"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m730.1,203.88c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="260.09"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m730.1,257.82c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="312.97"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m730.1,310.7c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="340.33"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m730.1,338.06c-.77-.55-1.82-.64-2.67-.24-1.69.8-2.07,2.88-.96,4.21.1.12.21.23.33.33.32.27.51.67.51,1.09,0,.58-.35,1.1-.88,1.31-.5.21-.97.49-1.39.83,1.01.67,2.21,1.07,3.51,1.07s2.51-.39,3.51-1.07c-.42-.34-.88-.61-1.38-.82-.54-.22-.89-.74-.89-1.32,0-.42.18-.81.49-1.08,1.33-1.11,1.33-3.22-.19-4.31Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="233.34"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m731.5,236.68c.19-.1.27-.33.19-.53-.15-.37-.29-.75-.29-1.15v-2.09c0-.29-.05-.58-.13-.85-.02-.07-.04-.15-.06-.22,0,0,0-.01,0-.02-.23-.66-.67-1.26-1.5-1.63-.77-.34-1.68-.35-2.42.04-.81.42-1.29,1.13-1.46,1.9-.07.25-.11.51-.11.78v2.09c0,.4-.12.77-.28,1.13-.02.05-.04.11-.04.17,0,.23.19.42.42.43h1.27c-.16.29-.41.52-.73.65-.59.24-1.13.59-1.61,1.01.38.29.8.54,1.24.74l.17.08c.74.3,1.55.48,2.4.48s1.67-.17,2.42-.48l.14-.06c.45-.2.87-.45,1.26-.75-.48-.42-1.02-.76-1.6-1-.32-.13-.57-.36-.73-.65h1.26c.07,0,.14-.02.2-.05Z"
                        />
                    </g>
                    <g>
                        <circle
                            className="s2_14"
                            cx="728.55"
                            cy="286.84"
                            r="6.32"
                        />
                        <path
                            className="s2_13"
                            d="m731.5,290.17c.19-.1.27-.33.19-.53-.15-.37-.29-.75-.29-1.15v-2.09c0-.29-.05-.58-.13-.85-.02-.07-.04-.15-.06-.22,0,0,0-.01,0-.02-.23-.66-.67-1.26-1.5-1.63-.77-.34-1.68-.35-2.42.04-.81.42-1.29,1.13-1.46,1.9-.07.25-.11.51-.11.78v2.09c0,.4-.12.77-.28,1.13-.02.05-.04.11-.04.17,0,.23.19.42.42.43h1.27c-.16.29-.41.52-.73.65-.59.24-1.13.59-1.61,1.01.38.29.8.54,1.24.74l.17.08c.74.3,1.55.48,2.4.48s1.67-.17,2.42-.48l.14-.06c.45-.2.87-.45,1.26-.75-.48-.42-1.02-.76-1.6-1-.32-.13-.57-.36-.73-.65h1.26c.07,0,.14-.02.2-.05Z"
                        />
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="206.6"
                            x2="776.78"
                            y2="206.6"
                        />
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="233.34"
                            x2="776.78"
                            y2="233.34"
                        />
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="260.09"
                            x2="776.78"
                            y2="260.09"
                        />
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="286.84"
                            x2="776.78"
                            y2="286.84"
                        />
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="313.58"
                            x2="776.78"
                            y2="313.58"
                        />
                        <line
                            className="s2_3"
                            x1="740.93"
                            y1="340.33"
                            x2="776.78"
                            y2="340.33"
                        />
                    </g>
                </g>
                <g>
                    <path
                        className="s2_15"
                        d="m160.26,312.5h340.93v263.98c0,1.1-.9,2-2,2H162.26c-1.1,0-2-.9-2-2v-263.98h0Z"
                    />
                    <rect
                        className="s2_32"
                        x="160.26"
                        y="312.5"
                        width="340.93"
                        height="109.74"
                    />
                    <rect
                        className="s2_30"
                        x="183.19"
                        y="443.2"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <rect
                        className="s2_31"
                        x="285.56"
                        y="443.2"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <rect
                        className="s2_35"
                        x="387.94"
                        y="443.2"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <rect
                        className="s2_33"
                        x="183.19"
                        y="504.11"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <rect
                        className="s2_34"
                        x="285.56"
                        y="504.11"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <rect
                        className="s2_28"
                        x="387.94"
                        y="504.11"
                        width="92.81"
                        height="49.03"
                        rx="1.81"
                        ry="1.81"
                    />
                    <g>
                        <line
                            className="s2_3"
                            x1="218.45"
                            y1="463.88"
                            x2="262.74"
                            y2="463.88"
                        />
                        <line
                            className="s2_3"
                            x1="218.45"
                            y1="472.37"
                            x2="248.7"
                            y2="472.37"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m208.01,473.79h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="218.45"
                            y1="524.79"
                            x2="262.74"
                            y2="524.79"
                        />
                        <line
                            className="s2_3"
                            x1="218.45"
                            y1="533.28"
                            x2="248.7"
                            y2="533.28"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m208.01,534.7h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="319.99"
                            y1="463.88"
                            x2="364.28"
                            y2="463.88"
                        />
                        <line
                            className="s2_3"
                            x1="319.99"
                            y1="472.37"
                            x2="350.24"
                            y2="472.37"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m309.55,473.79h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="319.99"
                            y1="524.79"
                            x2="364.28"
                            y2="524.79"
                        />
                        <line
                            className="s2_3"
                            x1="319.99"
                            y1="533.28"
                            x2="350.24"
                            y2="533.28"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m309.55,534.7h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="421.53"
                            y1="463.88"
                            x2="465.82"
                            y2="463.88"
                        />
                        <line
                            className="s2_3"
                            x1="421.53"
                            y1="472.37"
                            x2="451.79"
                            y2="472.37"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m411.09,473.79h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                    <g>
                        <line
                            className="s2_3"
                            x1="421.53"
                            y1="524.79"
                            x2="465.82"
                            y2="524.79"
                        />
                        <line
                            className="s2_3"
                            x1="421.53"
                            y1="533.28"
                            x2="451.79"
                            y2="533.28"
                        />
                        <g className="s2_25">
                            <path
                                className="s2_13"
                                d="m411.09,534.7h-7.47c-.64,0-1.26-.26-1.72-.71-.46-.46-.71-1.07-.71-1.72v-7.29c0-.64.26-1.26.71-1.72.46-.46,1.07-.71,1.72-.71h7.47c.64,0,1.26.26,1.72.71.46.46.71,1.07.71,1.72v7.29c0,.64-.26,1.26-.71,1.72-.46.46-1.07.71-1.72.71Z"
                            />
                        </g>
                    </g>
                </g>
                <rect
                    className="s2_38"
                    x="204.27"
                    y="367.55"
                    width="252.9"
                    height="27.72"
                    rx="1"
                    ry="1"
                />
                <path
                    className="s2_4"
                    d="m447.51,211.2l-63.03.12c-23.39,0-42.35,18.96-42.35,42.35h0c0,23.39,18.96,42.35,42.35,42.35h131.8c23.39,0,42.35,18.96,42.35,42.35v.99c0,23.39-18.96,42.35-42.35,42.35h-59.12"
                />
                <g>
                    <path
                        className="s2_1"
                        d="m431.16,380.15c0-3.15,2.55-5.7,5.7-5.7h0c-3.15,0-5.7,2.55-5.7,5.7s2.55,5.7,5.7,5.7h0c-3.15,0-5.7-2.55-5.7-5.7Z"
                    />
                    <path
                        className="s2_1"
                        d="m436.45,376.76c-1.78,0-3.27,1.38-3.27,3.19v.08c0,.42.34.75.75.75s.75-.34.75-.75v-.08c0-.91.76-1.68,1.76-1.68.42,0,.75-.34.75-.75s-.34-.75-.75-.75Z"
                    />
                    <path
                        className="s2_19"
                        d="m446.05,387.62l-3.33-3.33c.85-1.18,1.35-2.62,1.35-4.19,0-3.98-3.23-7.21-7.21-7.21s-7.21,3.23-7.21,7.21,3.23,7.21,7.21,7.21c1.44,0,2.78-.43,3.91-1.16l3.37,3.37c.53.53,1.38.53,1.91,0,.53-.53.53-1.38,0-1.91Zm-9.19-1.77h0c-3.15,0-5.7-2.55-5.7-5.7s2.55-5.7,5.7-5.7h0c3.15,0,5.7,2.55,5.7,5.7s-2.55,5.7-5.7,5.7Z"
                    />
                </g>
                <rect
                    className="s2_19"
                    x="254.43"
                    y="377.91"
                    width="152.93"
                    height="7"
                />
                <g>
                    <g>
                        <rect
                            className="s2_8"
                            x="271.76"
                            y="167.47"
                            width="60"
                            height="60"
                        />
                        <path
                            className="s2_9"
                            d="m324.4,221.48c-1.52-1.18-3.84-2.5-6.11-3.72.42,2.51.94,4.92,1.52,6.51.36.98-.47,1.99-1.5,1.84-2.19-.34-5.25-1.47-7.44-4.94-.05-.08-.09-.16-.14-.24-2.13,2.3-5.21,3.74-8.65,3.74s-6.59-1.3-8.71-3.51c0,0,0,0,0,0-2.2,3.47-5.25,4.6-7.44,4.94-1.03.16-1.85-.86-1.5-1.84.59-1.6,1.1-4.01,1.52-6.52-2.19,1.04-4.45,2.13-6.12,3.24-3.09,2.05-5.18,4.2-6.51,6.28.03.07.08.13.11.19h57.28c-1.43-1.82-3.47-3.8-6.3-5.98Z"
                        />
                    </g>
                    <g>
                        <path
                            className="s2_1"
                            d="m311.37,206.96c-.03.07-.05.14-.08.21.03-.07.06-.14.08-.21Z"
                        />
                        <path
                            className="s2_1"
                            d="m311.58,206.34c-.03.08-.05.15-.08.23.03-.08.05-.15.08-.23Z"
                        />
                        <path
                            className="s2_1"
                            d="m311.78,205.69c-.02.08-.05.17-.07.25.02-.08.05-.17.07-.25Z"
                        />
                        <path
                            className="s2_1"
                            d="m311.12,207.55c-.03.06-.06.13-.08.19.03-.06.06-.13.08-.19Z"
                        />
                        <path
                            className="s2_1"
                            d="m310.86,208.13c-.03.06-.05.11-.08.17.03-.06.06-.11.08-.17Z"
                        />
                        <path
                            className="s2_1"
                            d="m312.34,202.07c0,.09-.01.17-.02.26,0-.09.01-.17.02-.26Z"
                        />
                        <path
                            className="s2_1"
                            d="m312.29,202.85c0,.1-.02.19-.03.29.01-.1.02-.19.03-.29Z"
                        />
                        <path
                            className="s2_1"
                            d="m311.95,205.02c-.02.09-.04.18-.07.27.02-.09.05-.18.07-.27Z"
                        />
                        <path
                            className="s2_1"
                            d="m312.09,204.32c-.02.1-.04.19-.06.28.02-.09.04-.19.06-.28Z"
                        />
                        <path
                            className="s2_1"
                            d="m312.21,203.6c-.01.1-.03.2-.05.29.02-.1.03-.19.05-.29Z"
                        />
                        <path
                            className="s2_1"
                            d="m310.58,208.67s-.05.09-.08.14c.03-.05.05-.09.08-.14Z"
                        />
                        <path
                            className="s2_1"
                            d="m293.78,209.09c-.1-.16-.19-.33-.28-.5.09.17.18.34.28.5Z"
                        />
                        <path
                            className="s2_1"
                            d="m292.3,205.58c.04.14.08.27.12.4-.04-.13-.08-.27-.12-.4,0,0,0,0,0,0Z"
                        />
                        <path
                            className="s2_1"
                            d="m294.01,209.48c.04.07.08.13.13.19,0,0,0,0,0,0-.04-.06-.09-.13-.13-.19Z"
                        />
                        <path
                            className="s2_1"
                            d="m293.29,208.18c-.08-.16-.15-.32-.23-.49.07.16.15.33.23.49Z"
                        />
                        <path
                            className="s2_1"
                            d="m292.88,207.26c-.12-.28-.22-.57-.33-.86.1.3.21.58.33.86Z"
                        />
                        <path
                            className="s2_29"
                            d="m310.28,209.2s-.05.08-.07.11c.02-.04.05-.08.07-.11Z"
                        />
                        <path
                            className="s2_10"
                            d="m308.94,211.08s0,0,0,0c-1.68,1.98-3.57,3.11-4.64,3.55-.43.18-.9.27-1.37.27h-1.91c-.49,0-.97-.09-1.41-.28-1.32-.57-2.95-1.74-4.39-3.46.02.03.05.06.07.09.3,3.14.17,6.57-1.94,9.92,2.13,2.21,5.24,3.5,8.71,3.5s6.53-1.43,8.65-3.74c-2.01-3.33-2.1-6.74-1.79-9.85Z"
                        />
                        <path
                            className="s2_42"
                            d="m294.98,210.85c-.11-.13-.21-.27-.32-.41.1.14.21.28.32.41Z"
                        />
                        <path
                            className="s2_43"
                            d="m309.97,209.7s-.04.06-.06.09c.02-.03.04-.06.06-.09Z"
                        />
                        <path
                            className="s2_41"
                            d="m309.3,210.64s-.02.02-.02.03c0-.01.02-.02.02-.03Z"
                        />
                        <path
                            className="s2_40"
                            d="m309.64,210.18s-.03.04-.04.06c.01-.02.03-.04.04-.06Z"
                        />
                        <path
                            className="s2_39"
                            d="m294.14,209.67c.1.15.2.3.3.45-.1-.15-.2-.3-.3-.45,0,0,0,0,0,0Z"
                        />
                        <path
                            className="s2_10"
                            d="m299.61,214.61c.43.19.92.28,1.41.28h1.91c.48,0,.95-.09,1.37-.27,1.07-.44,2.96-1.57,4.64-3.55.11-.13.22-.27.33-.41,0-.01.02-.02.02-.03.1-.13.2-.26.3-.4.01-.02.03-.04.04-.06.09-.13.18-.26.27-.39.02-.03.04-.06.06-.09.08-.13.16-.26.25-.39.02-.04.05-.08.07-.11.08-.13.15-.25.22-.38.03-.05.05-.09.08-.14.07-.12.13-.25.2-.38.03-.06.06-.11.08-.17.06-.13.12-.25.18-.38.03-.06.06-.13.08-.19.05-.13.11-.26.16-.39.03-.07.06-.14.08-.21.05-.13.09-.26.14-.39.03-.08.05-.15.08-.23.04-.13.08-.26.12-.39.02-.08.05-.17.07-.25.04-.13.07-.27.1-.4.02-.09.05-.18.07-.27.03-.14.06-.27.09-.41.02-.09.04-.19.06-.28.03-.14.05-.29.07-.43.02-.1.03-.19.05-.29.02-.15.04-.3.05-.46.01-.1.02-.19.03-.29.02-.17.02-.34.03-.52,0-.09.01-.17.02-.26.01-.23.01-.47.02-.71-1.22-3.24-4.82-11.21-11.24-13.03-1.75,4.12-5.93,7.33-8.46,8.98l-.84,3.14h-.07c-.01.27-.03.54-.03.82,0,1.57.21,3,.58,4.31-.53.41-1.07-.3-1.48-1.42.41,1.13.95,1.84,1.48,1.42,0,0,0,0,0,0,.04.14.08.27.12.4.04.14.08.29.13.43.1.3.21.58.33.86.06.15.12.29.19.43.07.16.15.33.23.49.07.14.14.28.21.41.09.17.18.34.28.5.08.13.15.26.23.39.04.07.08.13.13.19.1.15.2.31.3.45.08.11.15.21.23.32.1.14.21.28.32.41.08.1.16.2.24.3,1.44,1.72,3.07,2.88,4.39,3.46Z"
                        />
                        <path
                            className="s2_11"
                            d="m285.91,226.11c2.19-.34,5.25-1.47,7.44-4.94,0,0,0,0,0,0,2.11-3.35,2.24-6.78,1.94-9.92-.02-.03-.05-.06-.07-.09-.08-.1-.16-.2-.24-.3-.11-.13-.21-.27-.32-.41-.08-.11-.16-.21-.23-.32-.1-.15-.2-.3-.3-.45-.04-.07-.09-.13-.13-.19-.08-.13-.15-.26-.23-.39-.1-.16-.19-.33-.28-.5-.07-.13-.14-.27-.21-.41-.08-.16-.15-.32-.23-.49-.06-.14-.13-.28-.19-.43-.12-.28-.22-.57-.33-.86-.05-.14-.09-.28-.13-.43-.04-.13-.09-.26-.12-.4-.53.41-1.07-.29-1.48-1.42,0,0,0-.02,0-.02-.03-.08-.06-.17-.08-.25,0-.02-.01-.03-.02-.05-.03-.08-.05-.16-.07-.25,0-.02-.01-.05-.02-.07-.02-.08-.04-.16-.06-.24,0-.03-.02-.06-.02-.1-.02-.08-.04-.15-.05-.23,0-.04-.02-.08-.03-.11-.02-.07-.03-.15-.05-.22,0-.04-.02-.09-.03-.13-.01-.07-.03-.14-.04-.21,0-.05-.02-.1-.02-.15-.01-.07-.02-.13-.03-.2,0-.05-.01-.11-.02-.16,0-.06-.02-.13-.02-.19,0-.06-.01-.11-.02-.17,0-.06-.01-.12-.02-.18,0-.06,0-.12-.01-.18,0-.06,0-.11-.01-.17,0-.06,0-.12,0-.18,0-.06,0-.11,0-.16,0-.06,0-.12,0-.18,0-.05,0-.1,0-.16,0-.06,0-.12,0-.17,0-.05,0-.1,0-.15,0-.06,0-.11.01-.17,0-.05,0-.09.01-.14,0-.06.01-.11.02-.16,0-.04.01-.09.02-.13,0-.05.02-.1.03-.16,0-.04.01-.08.02-.12,0,0,0-.01,0-.02,0,0,0,0,0,0,.32-.36.7-.68,1.11-.92.05-.03.11-.07.17-.1.23.67.15,2.46.15,2.46h.01s.07.01.07.01l.84-3.14c2.54-1.66,6.71-4.86,8.46-8.98,6.42,1.82,10.02,9.8,11.24,13.03,0,.24,0,.48-.02.71,0,.09-.01.17-.02.26-.01.17-.02.35-.03.52,0,.1-.02.19-.03.29-.02.15-.03.31-.05.46-.01.1-.03.2-.05.29-.02.14-.04.29-.07.43-.02.1-.04.19-.06.28-.03.14-.06.28-.09.41-.02.09-.04.18-.07.27-.03.14-.07.27-.1.4-.02.08-.05.17-.07.25-.04.13-.08.27-.12.39-.03.08-.05.15-.08.23-.05.13-.09.26-.14.39-.03.07-.05.14-.08.21-.05.13-.1.26-.16.39-.03.06-.06.13-.08.19-.06.13-.12.26-.18.38-.03.06-.05.11-.08.17-.06.13-.13.26-.2.38-.03.05-.05.09-.08.14-.07.13-.15.26-.22.38-.02.04-.05.08-.07.11-.08.13-.16.26-.25.39-.02.03-.04.06-.06.09-.09.13-.18.27-.27.39-.01.02-.03.04-.04.06-.1.14-.2.27-.3.4,0,.01-.02.02-.02.03-.11.14-.22.27-.33.41,0,0,0,0,0,0-.31,3.11-.23,6.52,1.79,9.85.05.08.09.16.14.24,2.2,3.47,5.25,4.6,7.44,4.94,1.03.16,1.85-.86,1.5-1.84-.58-1.59-1.1-4-1.52-6.51-.78-4.65-1.27-9.68-1.34-10.66-.09-1.2-.2-2.33-.33-3.4-.07-5.76-1.43-22.63-14.68-22.63-14.97,0-14.45,21.91-14.45,21.91l.26-.38c-.19,1.39-.35,2.87-.47,4.5-.07.98-.56,6-1.34,10.64-.42,2.52-.94,4.93-1.52,6.52-.36.98.47,1.99,1.5,1.84Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.32,202.13c-.01-.07-.02-.13-.03-.2,0,.07.02.13.03.2Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.19,201.06c0-.06,0-.11-.01-.17,0,.06,0,.11.01.17Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.22,201.41c0-.06-.01-.12-.02-.18,0,.06.01.12.02.18Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.17,200.71c0-.06,0-.11,0-.16,0,.05,0,.11,0,.16Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.61,203.51c-.02-.08-.04-.16-.06-.24.02.08.04.16.06.24Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.71,203.83c-.03-.08-.05-.16-.07-.25.02.08.05.16.07.25Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.27,201.77c0-.06-.02-.13-.02-.19,0,.06.02.13.02.19Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.38,202.49c-.01-.07-.03-.14-.04-.21.01.07.02.14.04.21Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.17,200.37c0-.05,0-.1,0-.16,0,.05,0,.1,0,.16Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.27,199.14s.01-.08.02-.12c0,.04-.02.08-.02.12Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.22,199.42s.01-.09.02-.13c0,.04-.01.08-.02.13Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.17,200.04s0-.1,0-.15c0,.05,0,.1,0,.15Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.19,199.72s0-.09.01-.14c0,.04,0,.09-.01.14Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.45,202.84c-.02-.07-.03-.15-.05-.22.01.07.03.15.05.22Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.81,204.13c-.03-.08-.06-.17-.08-.25.03.09.06.17.08.25Z"
                        />
                        <path
                            className="s2_16"
                            d="m290.53,203.18c-.02-.08-.04-.15-.05-.23.02.08.03.15.05.23Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.34,202.28s-.02-.1-.02-.15c0,.05.02.1.02.15Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.34,202.28s-.02-.1-.02-.15c0,.05.02.1.02.15Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.29,201.93c0-.05-.01-.11-.02-.16,0,.05.01.11.02.16Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.29,201.93c0-.05-.01-.11-.02-.16,0,.05.01.11.02.16Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.4,202.62s-.02-.09-.03-.13c0,.04.02.09.03.13Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.4,202.62s-.02-.09-.03-.13c0,.04.02.09.03.13Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.18,200.89c0-.06,0-.12,0-.18,0,.06,0,.12,0,.18Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.18,200.89c0-.06,0-.12,0-.18,0,.06,0,.12,0,.18Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.3,199s0,.01,0,.02c0,0,0-.01,0-.02,0,0,0,0,0,0Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.3,199s0,.01,0,.02c0,0,0-.01,0-.02,0,0,0,0,0,0Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.64,203.59s-.01-.05-.02-.07c0,.02.01.05.02.07Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.64,203.59s-.01-.05-.02-.07c0,.02.01.05.02.07Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.82,204.16s0-.02,0-.02c0,0,0,.02,0,.02Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.82,204.16s0-.02,0-.02c0,0,0,.02,0,.02Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.72,203.88s-.01-.03-.02-.05c0,.02.01.03.02.05Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.72,203.88s-.01-.03-.02-.05c0,.02.01.03.02.05Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.24,199.29c0-.05.02-.1.03-.16-.01.05-.02.1-.03.16Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.24,199.29c0-.05.02-.1.03-.16-.01.05-.02.1-.03.16Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.24,201.58c0-.06-.01-.11-.02-.17,0,.06.01.11.02.17Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.24,201.58c0-.06-.01-.11-.02-.17,0,.06.01.11.02.17Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.2,199.58c0-.06.01-.11.02-.16,0,.05-.01.11-.02.16Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.2,199.58c0-.06.01-.11.02-.16,0,.05-.01.11-.02.16Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.21,201.23c0-.06,0-.12-.01-.18,0,.06,0,.12.01.18Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.21,201.23c0-.06,0-.12-.01-.18,0,.06,0,.12.01.18Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.17,200.54c0-.06,0-.12,0-.18,0,.06,0,.12,0,.18Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.17,200.54c0-.06,0-.12,0-.18,0,.06,0,.12,0,.18Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.17,200.21c0-.06,0-.12,0-.17,0,.06,0,.12,0,.17Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.17,200.21c0-.06,0-.12,0-.17,0,.06,0,.12,0,.17Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.18,199.89c0-.06,0-.11.01-.17,0,.06,0,.11-.01.17Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.18,199.89c0-.06,0-.11.01-.17,0,.06,0,.11-.01.17Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.47,202.95s-.02-.08-.03-.11c0,.04.02.08.03.11Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.47,202.95s-.02-.08-.03-.11c0,.04.02.08.03.11Z"
                        />
                        <path
                            className="s2_17"
                            d="m290.55,203.28s-.02-.06-.02-.1c0,.03.02.06.02.1Z"
                        />
                        <path
                            className="s2_46"
                            d="m290.55,203.28s-.02-.06-.02-.1c0,.03.02.06.02.1Z"
                        />
                        <path
                            className="s2_16"
                            d="m292.3,205.58c-.36-1.31-.58-2.74-.58-4.31,0-.28.02-.55.03-.83h-.01s.08-1.79-.15-2.46c-.06.03-.12.07-.17.1-.42.25-.79.56-1.11.92,0,0,0,.01,0,.02,0,.04-.02.08-.02.12-.01.05-.02.1-.03.16,0,.04-.01.08-.02.13,0,.05-.01.11-.02.16,0,.04,0,.09-.01.14,0,.06,0,.11-.01.17,0,.05,0,.1,0,.15,0,.06,0,.12,0,.17,0,.05,0,.1,0,.16,0,.06,0,.12,0,.18,0,.05,0,.11,0,.16,0,.06,0,.12,0,.18,0,.06,0,.11.01.17,0,.06,0,.12.01.18,0,.06.01.12.02.18,0,.06.01.11.02.17,0,.06.02.13.02.19,0,.05.01.11.02.16,0,.07.02.13.03.2,0,.05.02.1.02.15.01.07.02.14.04.21,0,.04.02.09.03.13.01.07.03.15.05.22,0,.04.02.08.03.11.02.08.03.15.05.23,0,.03.02.06.02.1.02.08.04.16.06.24,0,.02.01.05.02.07.02.08.05.17.07.25,0,.02.01.03.02.05.03.09.06.17.08.25,0,0,0,.02,0,.02.4,1.13.95,1.84,1.48,1.42Z"
                        />
                        <path
                            className="s2_10"
                            d="m292.3,205.58c-.36-1.31-.58-2.74-.58-4.31,0-.28.02-.55.03-.83h-.01s.08-1.79-.15-2.46c-.06.03-.12.07-.17.1-.42.25-.79.56-1.11.92,0,0,0,.01,0,.02,0,.04-.02.08-.02.12-.01.05-.02.1-.03.16,0,.04-.01.08-.02.13,0,.05-.01.11-.02.16,0,.04,0,.09-.01.14,0,.06,0,.11-.01.17,0,.05,0,.1,0,.15,0,.06,0,.12,0,.17,0,.05,0,.1,0,.16,0,.06,0,.12,0,.18,0,.05,0,.11,0,.16,0,.06,0,.12,0,.18,0,.06,0,.11.01.17,0,.06,0,.12.01.18,0,.06.01.12.02.18,0,.06.01.11.02.17,0,.06.02.13.02.19,0,.05.01.11.02.16,0,.07.02.13.03.2,0,.05.02.1.02.15.01.07.02.14.04.21,0,.04.02.09.03.13.01.07.03.15.05.22,0,.04.02.08.03.11.02.08.03.15.05.23,0,.03.02.06.02.1.02.08.04.16.06.24,0,.02.01.05.02.07.02.08.05.17.07.25,0,.02.01.03.02.05.03.09.06.17.08.25,0,0,0,.02,0,.02.4,1.13.95,1.84,1.48,1.42Z"
                        />
                    </g>
                </g>
                <g>
                    <g className="s2_27">
                        <path
                            className="s2_23"
                            d="m562.39,413.4h0s-2.01-2.9-.98-4l-.05.03c1.57-1.65,2.52-3.73,2.52-5.99,0-5.31-5.18-9.63-11.54-9.63s-11.54,4.32-11.54,9.63,5.18,9.63,11.54,9.63c1.82,0,3.54-.37,5.07-.99,1.29,1.31,2.93,2.02,4.15,2.2h0c.07.02.14.04.21.04.11,0,.22-.03.31-.08.1-.05.18-.13.24-.22.06-.09.1-.2.11-.3,0-.11,0-.22-.05-.32Z"
                        />
                    </g>
                    <ellipse
                        className="s2_37"
                        cx="552.34"
                        cy="403.44"
                        rx="8.98"
                        ry="7.06"
                    />
                    <path
                        className="s2_21"
                        d="m557.32,400.54h-9.23c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h9.23c.64,0,1.15-.52,1.15-1.15s-.52-1.15-1.15-1.15Z"
                    />
                    <path
                        className="s2_22"
                        d="m551.55,404.73h-3.46c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h3.46c.64,0,1.15-.52,1.15-1.15s-.52-1.15-1.15-1.15Z"
                    />
                </g>
                <g>
                    <rect
                        className="s2_12"
                        x="575.91"
                        y="392.87"
                        width="60"
                        height="60"
                    />
                    <g>
                        <path
                            className="s2_6"
                            d="m614.88,431.82c-2.39-.52-3.52-3.09-4.01-4.74-2.05-.85-3.99-1.82-5.81-2.85-.03,2.65-.33,10.88-2.68,12.39-.88.57-1.97,1.21-3.12,1.77l.33,2.78c7.49-2.4,12.87-5.36,15.56-7.03l-.28-2.32Z"
                        />
                        <path
                            className="s2_7"
                            d="m610.87,427.08c.49,1.65,1.62,4.22,4.01,4.74.49.11,1.03.13,1.63.04,1.44-.22,1.65-1.45,1.24-3.08-.52.26-.86.34-.86.34-2.09-.53-4.1-1.23-6.02-2.03Z"
                        />
                        <path
                            className="s2_7"
                            d="m603.51,423.32c.51.31,1.02.61,1.55.91,1.81,1.03,3.76,2,5.81,2.85,1.92.8,3.94,1.5,6.02,2.03,0,0,.34-.08.86-.34,1.47-.73,4.41-2.85,5.6-8.52l-2.6-3.1s1.89-2.25,1.69-4.1-12.45-12.44-20.61-8.68c0,0-5.04-2.3-8.17-.78s-3.14,9.41-3.14,9.41c0,0,.14.15.39.4,1.31,1.35,5.96,5.88,12.61,9.91Z"
                        />
                        <path
                            className="s2_5"
                            d="m592.62,452.25s.04-.06.06-.1c.24-.36.48-.72.72-1.06.09-.13.18-.25.27-.38.17-.24.34-.47.52-.7.11-.14.21-.28.32-.41.16-.21.32-.41.49-.62.11-.14.23-.27.34-.41.16-.19.33-.38.49-.57.11-.13.23-.26.34-.39.13-.15.27-.29.4-.44l3.85-1.36s-.02.03-.03.05c.01-.01.02-.03.04-.04l.28-.1,7.92-2.8c3.4-.49,6.37-2.55,8.02-5.56l.02-.16c2.3,1.73,7.5,6.94,11.3,15.7h-32.03s-.01,0-.01,0h-3.73c.13-.22.27-.43.41-.64Z"
                        />
                        <path
                            className="s2_7"
                            d="m600.72,445.71l7.92-2.8c3.4-.49,6.37-2.55,8.02-5.56l.02-.16.44-4.36s-.68.5-1.96,1.3c-2.69,1.67-8.07,4.63-15.56,7.03-.61.19-1.22.39-1.86.57l-1.25,5.47.1-.03,3.85-1.36.28-.1Z"
                        />
                        <path
                            className="s2_6"
                            d="m593.22,436.62c1.53.08,6.95-2.41,8.13-4.1s1.15-3.79,1.46-5.45l.69-3.74c-6.65-4.03-11.29-8.57-12.61-9.91-1.12,3.83-.51,7.63-.51,7.63-1.24,1.3-3,4.93-2.96,6.02.05,1.09,2.7,1.15,2.7,1.15l1,6.61c.36,1.51.56,1.71,2.09,1.79Z"
                        />
                        <path
                            className="s2_7"
                            d="m605.05,424.23c-.53-.3-1.05-.6-1.55-.91l-.69,3.74c-.31,1.66-1.44,3.06-3.02,3.66-.84.32-1.58.81-2.19,1.34-1.14.97-2.89.6-3.51-.76-.33-.72-.64-1.41-.85-1.87-.48-1.06-2.22-1.05-3.06-.98-.28.02-.46.05-.46.05-.32,1.29.56,2.27.56,2.27,0,0,2.03-.5,2.59.66,1.07,2.64-.34,3.12-.8,2.85-.42-.24.03-1.21-.52-1.25-.44-.03-1.19-.11-1.14.43.16,1.97.78,5.2,2.04,6.01,1.57,1.01,4.34.14,6.83-1.08,1.15-.56,2.23-1.2,3.12-1.77,2.35-1.51,2.64-9.74,2.68-12.39Z"
                        />
                    </g>
                </g>
                <g>
                    <path
                        className="s2_20"
                        d="m688.82,203.36l9.19.97c1.27.13,2.19,1.27,2.05,2.54l-.97,9.19c-.13,1.27-1.27,2.19-2.54,2.05l-9.19-.97c-1.27-.13-2.19-1.27-2.05-2.54l.97-9.19c.13-1.27,1.27-2.19,2.54-2.05Z"
                    />
                    <path
                        className="s2_26"
                        d="m689.79,209.35c.13.07.25.18.35.3l1.33,1.64,4.18-3.38c.12-.1.25-.17.4-.22.15-.05.3-.06.45-.05s.3.06.44.13c.14.07.25.17.35.29.1.12.17.26.21.4.04.15.06.3.04.45-.02.15-.07.3-.14.43-.07.13-.18.25-.3.35l-5.08,4.11c-.24.19-.54.28-.85.25s-.58-.18-.78-.42l-2.05-2.54c-.1-.12-.17-.25-.22-.4-.05-.15-.06-.3-.05-.45s.06-.3.13-.44c.07-.14.17-.25.29-.35.12-.1.26-.17.4-.21.15-.04.3-.06.45-.04.15.02.3.07.43.14Z"
                    />
                </g>
            </g>
        </g>
    </svg>
);
